module.exports = __webpack_public_path__ + "img/AutoGrey.65bb919c.svg";